module.exports = __webpack_public_path__ + "img/mobi_P2.b50414c7.png";